import { useRef, useMemo } from 'react';
import { useLoadScript } from '../../../hooks/useLoadScript';
import '../config/betting-client-settings';

const getDailyCacheKey = () => {
  const today = new Date();
  const day = today.getDate();
  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  return `${day}-${month}-${year}`;
};

export const useKambiWidgetScript = () => {
  const dailyCacheKey = useMemo(() => getDailyCacheKey(), []);
  const status = useLoadScript(
    `https://static.kambicdn.com/client/widget-api/kambi-widget-api.js?cb=${dailyCacheKey}`
  );

  return status;
};
